module.exports = __webpack_public_path__ + "static/media/cancellationPolicy.f45b276f.svg";